import React from "react"
import { Box, Switch, Typography } from "@mui/material"
import { dsColorNew } from "@palette"
import { AppProvidersAutocomplete } from "@components/Autocomplete"
import useDsRepricingDataInfo from "Pages/DsRepricing/Page/@hooks/useDataInfo"
import { dsRepricingDrawerData, dsRepricingOriginalData } from "Pages/DsRepricing/Page/@signals"
import { enrichFilterIds } from "Pages/DsRepricing/Page/@utils/filterEnrich"

// Individual providers, next to the tier selector rather than inside it. A tier is a bucket of
// providers, so scoping by tier is the broad stroke and this is the precise one: "compare against
// Hertz and Avis" had no way to be said (Curro, 2026-09-19).
//
// The two are separate axes and both are applied. An empty axis means every provider, so a rule
// that only names tiers behaves exactly as it did before this field existed.
export default function DsRepricingFilterProviders() {
	const d = dsRepricingDrawerData.peek()
	const { dataInfo: idsInfo, setDataInfo: setIds } = useDsRepricingDataInfo(d.filterProviders ?? [])
	const { dataInfo: exclInfo, setDataInfo: setExcl } = useDsRepricingDataInfo(d.filterProvidersExclusion ?? false)

	const isExclusion = exclInfo.value
	const ids = idsInfo.value ?? []

	const updateMode = (checked) => setExcl(checked, 'filterProvidersExclusion')
	const updateIds = (_, opts) => setIds(opts ?? [], 'filterProviders')

	return (
		<Box>
			<Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
				<Switch checked={isExclusion} onChange={e => updateMode(e.target.checked)} size="small"/>
				<Typography sx={{ fontSize: 14, color: dsColorNew.textDark, fontWeight: 500 }}>
					{isExclusion ? 'Exclude providers' : 'Include providers'}
				</Typography>
			</Box>
			<AppProvidersAutocomplete
				multiple
				label="Providers"
				placeholder={isExclusion ? 'All providers except…' : 'All providers'}
				value={ids.map(o => o?.value ?? o)}
				onChange={updateIds}
				onAjax={options => { enrichFilterIds('filterProviders', options, dsRepricingDrawerData, dsRepricingOriginalData); return options }}
			/>
		</Box>
	)
}
